import WelcomeSec from "./WelcomeSec";

export default WelcomeSec;
